export var configParticlesBoostedField = {
    acceleration: {
        x: -3,
        y: -2,
    },
    addAtBack: false,
    alpha: {
        end: 0,
        start: 2.5,
    },
    blendMode: "normal",
    color: {
        end: "#ffffff",
        start: "#ffffff",
    },
    emitterLifetime: 0,
    frequency: 0.2,
    lifetime: {
        max: 2,
        min: 1,
    },
    maxParticles: 40,
    maxSpeed: 0,
    noRotation: false,
    pos: {
        x: 0,
        y: 0,
    },
    rotationSpeed: {
        max: 60,
        min: 50,
    },
    scale: {
        end: 0.8,
        minimumScaleMultiplier: 0.9,
        start: 0.1,
    },
    spawnRect: {
        h: 100,
        w: 250,
        x: -120,
        y: 0,
    },
    spawnType: "rect",
    speed: {
        end: 2,
        minimumSpeedMultiplier: 10,
        start: 1,
    },
    startRotation: {
        max: 0,
        min: 0,
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/particles/configParticlesBoostedField.ts
// module id = 2189
// module chunks = 3